import Menu from '@zenbusiness/zui/Menu';
import Stack from '@zenbusiness/zui/Stack';
import { styled } from '@zenbusiness/zui/styles';

const MenuStyle = ({ theme }) => ({
  '& .MuiPaper-root': {
    padding: '8px 0',
    border: `1px solid ${theme.palette.border.main}`,
    boxShadow: '0px 4px 16px 2px rgba(0, 0, 0, 0.12)',
    borderRadius: '16px'
  }
});

const LabelStyle = ({ bgColor }) => ({
  padding: '4px 12px',
  borderRadius: '16px',
  border: 'none',
  backgroundColor: bgColor,
  width: 'fit-content'
});

export const MenuStyled = styled(Menu)(MenuStyle);
export const LabelStyled = styled(Stack, {
  shouldForwardProp: (prop) => prop
})(LabelStyle);
